
import { defineComponent } from 'vue';
import BotoesEdicao from '../comum/BotoesEdicao.vue';
import { ModeloEditavel } from '@/dominio/editor/modelo/ModeloEditavel';

export default defineComponent({
    name: 'ModeloVisualizacao',
    components: { BotoesEdicao },
    props: {
        modelo: { type: ModeloEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    computed: {
        titulo() {
            let titulo = this.modelo.toString();
            if (titulo.length > 28) {
                titulo = titulo.substring(0, 25) + '...';
            }
            return titulo;
        },
    },
    methods: {
        editar() {
            this.$emit('editar', this.modelo);
        },
        excluir() {
            this.$emit('excluir', this.modelo);
        },
        descer() {
            this.$emit('descer', this.modelo);
        },
        subir() {
            this.$emit('subir', this.modelo);
        },
    },
    emits: ['excluir', 'descer', 'subir', 'editar'],
});
